<template>
    <div class="input-gen">
        <input
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            name="password"
            :type="visible ? 'text' : 'password'"
            :class="['custom-input-transparent', {'is-invalid': valid}]"
            placeholder="Contraseña"
            @focus="$emit('focus')"
        >

            <button
            type="button"
            class="password-toggle-btn"
            @click="togglePasswordVisibility"
            title="Mostrar/Ocultar contraseña"
        >
            <i :class="visible ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
        </button>

        <button
            type="button"
            class="password-gen-btn"
            @click="generatePassword"
            title="Generar contraseña segura"
        >
            <i class="fa-solid fa-wand-magic-sparkles"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        modelValue: [String, null],
        valid: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        togglePasswordVisibility() {
            this.$emit('update:visible', !this.visible)
        },
        generatePassword() {
            const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
            let password = "";
            for (let i = 0; i < 12; i++) {
                password += charset.charAt(Math.floor(Math.random() * charset.length));
            }
            this.$emit('newPassword', password)
        },
    }
}
</script>


<style>
.input-gen {
  position: relative;
}

.password-gen-btn,
.password-toggle-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0 6px;
}

.password-gen-btn {
  right: 6px;
}

.password-toggle-btn {
  right: 36px; /* Espacio para que no se empalme con el botón de generar */
}

.password-gen-btn:hover,
.password-toggle-btn:hover {
  color: var(--primary-color); /* O tu color preferido */
}

</style>